module.exports = __webpack_public_path__ + "media/virgin_to_rakuten.8c0ed1f1.png";